import { Route } from "react-router-dom";

import HomePage from "../pages/home";
import AboutUs from "../pages/aboutUs";
import Offers from "../pages/offers";
import Profile from "../pages/profile";
import Library from "../pages/masarLibrary";
import AdvancedServices from "../pages/advancedServices";
import Layout from "../layouts/layout";
import LogIn from "../features/loginAndRegister/logIn";
import Register from "../pages/register";
import ContactUs from "../pages/contactUs";
import NotFound from "../components/notFound";
import ActiveUserPassword from "../features/user/login/registerActiveUser";
import ResetPassword from "../features/loginAndRegister/resetPassword";
import LibraryBook from "../features/library/libraryBook";
import OffersDetails from "../features/offers/OffersDetails";
import AdvanceServiceDetails from "../features/AdvancedServices/AdvanceServiceDetails";
import { Terms, Policy } from "../pages/terms";
import { ServicesProviders } from "../features/serviceProvider/servicesProviders";
import { PaymentForm } from "../features/payment/CheckoutPaymob";
import { ServicesRoutes } from './ServicesRoutes';
import FAQ_Page from "../pages/FAQ";

export function HomeRoutes() {
    return (
        <Route element={<Layout />}>

            <Route path="/" element={<HomePage />} />
            {ServicesRoutes()}
            <Route path="aboutUs" element={<AboutUs />} />
            <Route path="offers" element={<Offers />} />
            <Route path="offers/:OfferId/:OfferTitle" element={<OffersDetails />} />
            <Route path="advancedServices" element={<AdvancedServices />} />
            <Route path="advancedServices/:AdServiceId" element={<AdvanceServiceDetails />} />
            <Route path="profile" element={<Profile />} />
            <Route path="masarLibrary" element={<Library />} />
            <Route path="masarLibrary/:bookSetId/:bookSetTitle" element={<LibraryBook />} />
            {/* <Route path="masarLibrary/:bookSetTitle" element={<LibraryBook />} /> */}

            <Route path="FAQ" element={<FAQ_Page />} />
            <Route path="terms" element={<Terms />} />
            <Route path="policy" element={<Policy />} />
            <Route path="servicesProviders" element={<ServicesProviders />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="payment" element={<PaymentForm />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/auth/reset-password/:token" element={<ActiveUserPassword />} />
            <Route path="logIn" element={<LogIn />} />
            <Route path="register" element={<Register />} />
            {/* <Route path="OTP" element={<OTPPage />} /> */}
            <Route path="resetPassword" element={<ResetPassword />} />
            {/* <Route path="adminLogin" element={<AdminLogIn />} /> */}
        </Route>
    );
}